<script lang="ts" setup>
import { eventPersonalMessage } from "@anggunpraya-templates/base/app/schemas/event";

const emit = defineEmits<{
  (e: "refresh"): void;
}>();

const formRef = useTemplateRef("formRef");
const { capabilities } = usePackageCapabilities();

const { state, loading, showAttendanceField, submit } = useWishesForm({
  onSubmitted: () => {
    emit("refresh");
  },
});

async function onSubmit() {
  await submit();
}

watchPostEffect(() => {
  if (capabilities.value.requiresGuestContext) {
    return;
  }

  if (state.value.status) {
    formRef.value?.clear("status");
  }
});
</script>

<template>
  <UForm
    ref="formRef"
    class="flex flex-col gap-6"
    :state="state"
    :schema="eventPersonalMessage"
    @submit="onSubmit"
    @error="highlightErrorField"
  >
    <UFormField
      name="guest_name"
      label="Nama"
    >
      <UInput
        v-model="state.guest_name"
        placeholder="Masukkan nama Anda"
        class="w-full"
      />
    </UFormField>

    <UFormField
      v-if="showAttendanceField"
      name="status"
      label="Kehadiran"
    >
      <div class="grid grid-cols-2 gap-3">
        <UButton
          type="button"
          block
          :variant="state.status === 'attending' ? 'solid' : 'outline'"
          @click="state.status = 'attending'"
        >
          Hadir
        </UButton>

        <UButton
          type="button"
          block
          :variant="state.status === 'not-attending' ? 'solid' : 'outline'"
          @click="state.status = 'not-attending'"
        >
          Tidak Hadir
        </UButton>
      </div>
    </UFormField>

    <UFormField
      name="message"
      label="Ucapan atau Doa"
    >
      <UTextarea
        v-model="state.message"
        class="w-full"
        placeholder="Tulis ucapan atau doa Anda di sini"
        autoresize
      />
    </UFormField>

    <UButton
      type="submit"
      class="mt-2"
      block
      :loading="loading.state"
    >
      <div class="flex items-center jusitfy-center gap-1.5">
        <span>
          Kirim Ucapan & Doa
        </span>
        <UIcon
          name="custom:paper-airplane"
          class="size-4"
        />
      </div>
    </UButton>
  </UForm>
</template>
